import { CSSResultGroup, html, TemplateResult } from 'lit';
import componentStyles from './idb-info-cards.css.lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement, property, state } from 'lit/decorators.js';
import { SlotController } from '../../controllers/slot-controller';

/**
 * The IDB Alternating Info Cards component
 * @element idb-info-cards
 * @extends OutlineElement
 * @slot - The default slot
 */
@customElement('idb-info-cards')
export class IdbInfoCards extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];
  slots = new SlotController(
    this, // This, the host element.
    true // To shift or not to shift LightDom nodes to ShadowDOM.
  );

  @state() cardCounter: number;
  @state() nextImage: 'left' | 'right';

  private contentCards: NodeListOf<HTMLElement>;

  firstUpdated(): void {
    this.contentCards = this.querySelectorAll('idb-content-card');
    this.cardCounter = this.contentCards.length;
    this.nextImage = this.firstImage;
    this.alterCards();
  }

  /**
   * The position of the first image in a content card..
   */
  @property({ type: String, attribute: 'first-image' })
  firstImage: 'left' | 'right' = 'left';

  render(): TemplateResult {
    return html`
      <section class="info-card-wrapper">
        <slot></slot>
      </section>
    `;
  }

  alterCards(): void {
    //console.log('Running alterCards method...');
    this.contentCards.forEach((card: HTMLElement) => {
      const next = this.nextImage === 'left' ? 'right' : 'left';
      card.setAttribute('image-position', this.nextImage);
      this.nextImage = next;
    });
  }
}
